import React from 'react';
import { Modal } from 'react-bootstrap';
import { Button } from '@spark/ui-components/components/Button';
import TanStackTable from '@spark/ui-components/components/TanStackTable/TanStackTable';
import FilterPanel from '@spark/ui-components/components/FilterPanel';
import { useClienteSelection } from './hooks/useClienteSelection';
import { getClienteColumns } from './config/clienteColumns';
import { clienteFilterConfig } from './config/clienteFilterConfig';

const ClienteSelectionModal = ({
  show,
  onHide,
  onSelect,
  currentValue,
}) => {
  const {
    clientes,
    loading,
    paginaAtual,
    quantidadePorPagina,
    totalRegistros,
    handleFiltrosChange,
    handlePaginationChange,
  } = useClienteSelection(show);

  const handleSelectCliente = (cliente) => {
    const selectedValue = {
      value: String(cliente.Id || cliente.id),
      label: cliente.Nome || cliente.nome || `Cliente ${cliente.Id || cliente.id}`,
    };
    onSelect(selectedValue);
  };

  return (
    <Modal show={show} onHide={onHide} animation={false} size="xl">
      <Modal.Header closeButton>
        <Modal.Title>Selecionar Cliente</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <FilterPanel
          filters={clienteFilterConfig}
          onApply={handleFiltrosChange}
          title="Filtros de Busca"
          loading={loading}
          defaultCollapsed={false}
        />

        <TanStackTable
          key={`cliente-selection-${paginaAtual}-${quantidadePorPagina}`}
          columns={getClienteColumns(handleSelectCliente)}
          data={clientes}
          loading={loading}
          withPagination={true}
          pageSizeOptions={[5, 10, 25, 50]}
          enableRowColors={true}
          className="mt-3"
          manualPagination={true}
          totalItems={totalRegistros}
          controlledPagination={{
            pageIndex: Math.max(0, (paginaAtual || 1) - 1),
            pageSize: quantidadePorPagina || 10,
          }}
          onPaginationChange={handlePaginationChange}
        />
      </Modal.Body>

      <Modal.Footer>
        <div className="d-flex justify-content-between w-100">
          <div className="text-muted">
            {totalRegistros > 0 && (
              <span>
                Exibindo {clientes.length} de {totalRegistros} cliente(s)
              </span>
            )}
          </div>
          <div>
            <Button variant="secondary" onClick={onHide}>
              Cancelar
            </Button>
          </div>
        </div>
      </Modal.Footer>
    </Modal>
  );
};

export default ClienteSelectionModal;
